var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-icons"},_vm._l((_vm.data),function(item,index){return _c('ProductIconsItem',{key:index,attrs:{"src":item.src,"name":item.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }